export const archiveFiscalType = [
  { label: "Archive journalière", value: "day" },
  { label: "Archive mensuelle", value: "month" },
  { label: "Archive annuelle", value: "year" },
];
